import {
  useStyle 
} from "@/classify"

import Shimmer from "../Shimmer"
import defaultClasses from "./breadcrumbs.module.css"

const BreadcrumbsShimmer = (props) => {
  const classes = useStyle(defaultClasses, props.classes)

  return (
    <div className={classes.root} aria-live='polite' aria-busy='true'>
      <Shimmer width={5} />
    </div>
  )
}

export default BreadcrumbsShimmer
